import { apiClient } from './client'

export interface PhotobookGeneratePayload {
  work_ids: number[]
  language: 'fr' | 'en'
}

export const photobookApi = {
  /**
   * Génère un PDF photobook avec la sélection ordonnée d'œuvres. L'ordre
   * exact des `work_ids` pilote l'ordre des spreads dans le PDF.
   * Le caller utilise `URL.createObjectURL(blob)` pour déclencher le
   * téléchargement côté client.
   */
  generate: async (payload: PhotobookGeneratePayload): Promise<Blob> => {
    const { data } = await apiClient.post<Blob>('/admin/photobook', payload, {
      responseType: 'blob',
    })
    return data
  },
}
